import { render, staticRenderFns } from "./TheMainCarousel.vue?vue&type=template&id=20aa4d96&"
import script from "./TheMainCarousel.vue?vue&type=script&lang=js&"
export * from "./TheMainCarousel.vue?vue&type=script&lang=js&"
import style0 from "./TheMainCarousel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports